module.exports = __webpack_public_path__ + "static/media/dadCutout-01.489ad2c3.jpg";